import { createSlice } from '@reduxjs/toolkit';
import type { RootState } from '.';
import type { InputsReducerTypes } from '../types';
import phoneNumberFormatter from '../functions/phoneNumberFormatter';

const initialState: InputsReducerTypes = {
  firstName: '',
  lastName: '',
  zipCode: '',
  email: '',
  preferredContactMethod: 'email',
  preferredContactTime: 'NO_PREFERENCE',
  phoneNumber: '',
  topicOfInterest: '',
  ccpa: false,
  universalConsent: false,
  dealerConsent: false,
  tcpaConsent: false,
  oemConsent: false,
  tradeInVehicleMake: '',
  tradeInVehicleModel: '',
  tradeInVehicleYear: '',
  tradeInVehicleMileage: '',
  tradeInVehicleVin: '',
  modelFamilyOfInterest: '',
  modelLineOfInterest: '',
  datePicker: '',
  preferedBookingTime: '',
  modelLinesSelected: [],
  modelLineSelectCustom: '',
  purchaseTimeFrame: '',
  preferredDealer: '',
};

const inputsSlice = createSlice({
  name: 'inputs',
  initialState,
  reducers: {
    setUserInputs: (state, action) => {
      const { inputName, inputValue } = action.payload;
      if (inputName === 'phoneNumber' && state.phoneNumber?.length < inputValue?.length) {
        return { ...state, phoneNumber: phoneNumberFormatter(inputValue) };
      }
      return { ...state, [inputName]: inputValue };
    },
    cleanInputs: (state) => {
      return {
        ...state,
        firstName: '',
        lastName: '',
        zipCode: '',
        email: '',
        phoneNumber: '',
        topicOfInterest: '',
        modelLinesSelected: [],
        purchaseTimeFrame: '',
        preferredDealer: '',
        modelFamilyOfInterest: '',
        modelLineOfInterest: '',
      };
    },
  },
});

export const selectInputs = (state: RootState) => state.userInputs;

export const { setUserInputs, cleanInputs } = inputsSlice.actions;

export default inputsSlice.reducer;
